function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createMemoStyles } from '@wds/utils';
var useStyles = createMemoStyles(function (_ref) {
  var palette = _ref.palette,
    spacing = _ref.spacing,
    type = _ref.type;
  return {
    inlineList: function inlineList(_ref2) {
      var noMargin = _ref2.noMargin;
      return {
        display: 'table',
        margin: noMargin ? 0 : [0, 0, spacing[4]],
        paddingLeft: 0,
        paddingRight: 0
      };
    },
    inlineListItem: function inlineListItem(_ref3) {
      var isTitle = _ref3.isTitle;
      return _objectSpread(_objectSpread({
        display: isTitle ? 'table-cell' : 'inline-block',
        listStyle: 'disc none',
        margin: [0, spacing[4], spacing[1], 0],
        position: 'relative',
        fontSize: type.fontSize.bodySm,
        color: palette.text.darkMuted
      }, isTitle && {
        fontWeight: type.fontWeight.medium,
        width: spacing[9],
        listStyleType: 'none'
      }), {}, {
        '&:last-child': {
          marginRight: 0
        }
      });
    },
    inlineListItemBullet: {
      position: 'absolute',
      right: -spacing[3],
      top: 0
    },
    inlineListItemAnchor: {
      color: palette.text.darkMuted,
      textDecoration: 'none',
      '&:visited': {
        color: palette.text.darkMuted
      },
      '&:hover, &:focus': {
        color: palette.text.dark,
        textDecoration: 'underline'
      }
    }
  };
});
export default useStyles;
//# sourceMappingURL=useStyles.js.map